import { useNavigate } from 'react-router-dom';
import { Home, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { trackEvent } from '@/lib/analytics';

export const AdminFooter = () => {
  const navigate = useNavigate();

  const handleMainSiteClick = () => {
    trackEvent('admin_footer_main_site_click', {});
    navigate('/');
  };

  const handleLinkClick = (target: string, href: string) => {
    trackEvent('admin_footer_link_click', { target });
    if (href.startsWith('/')) {
      navigate(href);
    } else {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <footer className="mt-12 pt-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8">
          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-foreground">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={handleMainSiteClick}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <Home className="h-4 w-4" />
                  Main Site
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('residences', '/residences')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  Residences
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('amenities', '/amenities')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  Amenities
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('about', '/about')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  About
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-foreground">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Grand Harbour, Grand Cayman, KY</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a
                  href="tel:+13451234567"
                  onClick={() => handleLinkClick('phone', 'tel:+13451234567')}
                  className="hover:text-foreground transition-colors"
                >
                  +1 (345) 123-4567
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:info@thepearl.ky"
                  onClick={() => handleLinkClick('email', 'mailto:info@thepearl.ky')}
                  className="hover:text-foreground transition-colors"
                >
                  info@thepearl.ky
                </a>
              </li>
            </ul>
          </div>

          {/* Admin Info */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-foreground">Admin Panel</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Site administration and analytics dashboard for The Pearl at Grand Harbour.
            </p>
            <Button
              variant="outline"
              size="sm"
              onClick={handleMainSiteClick}
              className="w-full sm:w-auto"
            >
              <Home className="mr-2 h-4 w-4" />
              View Main Site
            </Button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-border">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-muted-foreground text-center sm:text-left">
              © {new Date().getFullYear()} The Pearl at Grand Harbour. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground text-center sm:text-right">
              Admin Panel v1.0
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};







